import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BxButtonComponent, BxFileUploadComponent, injectBxIcons, upload03Icon } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import { ElsImportStatusReportComponent } from './els-import-status-report/els-import-status-report.component';
import { TadoDraginoImportService } from './tado-dragino-import.service';
import { resolveElsDeviceType } from './tado-dragino.models';

@Component({
  selector: 'bxi-tado-dragino-import',
  imports: [BxFileUploadComponent, BxButtonComponent, TranslatePipe, ElsImportStatusReportComponent],
  templateUrl: './tado-dragino-import.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TadoDraginoImportComponent {
  private readonly importService = inject(TadoDraginoImportService);
  protected readonly filesToUpload = signal<FileList | null>(null);

  protected readonly uploading = toSignal(this.importService.uploading$);
  protected readonly errorKey = toSignal(this.importService.errorKey$);
  protected readonly elsJobStatistics = toSignal(this.importService.elsJobStatistics$);

  constructor() {
    injectBxIcons([upload03Icon]);
  }

  protected onFileChanged(files: FileList | null): void {
    this.importService.setErrorKey(null);
    this.filesToUpload.set(files);
  }

  protected readFile(file: File): void {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = (e: ProgressEvent<FileReader>): void => {
      let elsJson;
      try {
        elsJson = JSON.parse(e.target?.result as string);
      } catch {
        this.importService.setErrorKey('system.errors.notValidJsonFormat');
        return;
      }

      const deviceType = resolveElsDeviceType(elsJson);
      if (!deviceType) {
        this.importService.setErrorKey('system.errors.notValidElsFile');
        return;
      }

      this.importService.uploadElsFile(file, deviceType);
    };
  }
}
